import React, { useState } from "react";
import { ChevronDown, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const FAQS = [
  {
    q: "How long will my rebounder last?",
    a: "Our rebounders are built with commercial-grade steel frames and premium bungees. With regular use they last 5+ years — the frame itself is backed by a lifetime warranty.",
  },
  {
    q: "Is a mini trampoline hard on my knees?",
    a: "Quite the opposite. Rebounding absorbs up to 80% of the impact a treadmill delivers, so it's one of the gentlest cardio workouts you can do while still burning serious calories.",
  },
  {
    q: "How much space do I need?",
    a: "The 44in Round fits in a 48×48 inch footprint — about the size of a small coffee table. You'll want at least 8 feet of vertical clearance for bouncing.",
  },
  {
    q: "How hard is assembly?",
    a: "Most customers assemble their rebounder in 10–15 minutes. Every unit ships with illustrated instructions, the required tools, and a video walkthrough.",
  },
  {
    q: "What is your return policy?",
    a: "Every GVB purchase is backed by a 30-Day Money-Back Guarantee. If you're not completely satisfied, send it back for a full refund — no questions asked.",
  },
  {
    q: "Do you ship internationally?",
    a: "We currently ship across the United States and Canada. International shipping is rolling out in 2026 — join our newsletter to be the first to know.",
  },
  {
    q: "How long does shipping take?",
    a: "Orders typically arrive within 3–5 business days with free shipping on orders over $50. You'll receive tracking info the moment your order leaves our warehouse.",
  },
  {
    q: "Can I use it outdoors?",
    a: "Yes — the frame is rust-resistant. We recommend storing it indoors or under cover when not in use to keep the bungees at their best.",
  },
];

const FAQPage = () => {
  const [open, setOpen] = useState(0);
  return (
    <main className="bg-[#FFF2EC]">
      <section className="coral-soft">
        <div className="max-w-4xl mx-auto px-4 py-14 md:py-20 text-center">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#DD4D2A] font-semibold mb-3">
            Help Center
          </div>
          <h1 className="font-serif-display text-5xl md:text-7xl font-semibold">
            Frequently <span className="italic">Asked</span>
          </h1>
          <p className="mt-5 text-[#1A1410]/70 max-w-xl mx-auto">
            Answers to the questions we hear most often. Can't find what you're
            looking for? Reach out on our contact page.
          </p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="bg-white rounded-2xl border border-[#1A1410]/10 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                >
                  <span className="font-serif-display text-lg md:text-xl font-semibold text-[#1A1410]">
                    {f.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-[#DD4D2A] flex-shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-[#1A1410]/75 leading-relaxed">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-12 bg-[#1A1410] text-[#FFF2EC] rounded-3xl p-7 md:p-10 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/10 mb-4">
            <MessageCircle className="w-5 h-5" />
          </div>
          <h3 className="font-serif-display text-2xl md:text-3xl font-semibold">
            Still have questions?
          </h3>
          <p className="mt-2 text-[#FFF2EC]/70">
            Our team replies to every message within 24 hours.
          </p>
          <Link
            to="/about"
            className="btn-coral inline-flex items-center mt-5 px-6 py-3 rounded-full text-sm uppercase"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
};

export default FAQPage;
